<template>
  <div class="orderManagementClass">
    <div class="orderManagementContent" :style="contentViewHeight">
      <div class="printOrderListBox">
        <div>
          <div class="orderSearchBox">
              <el-input
                  v-model="form.creatorName"
                  placeholder="设计师名称"
              ></el-input>
              <el-input
                  v-model="form.modelName"
                  placeholder="模型名称"
              ></el-input>
              <el-select v-model="form.typeFirstUuid" placeholder="一级分类" @change="classificationOneChange">
                  <el-option
                      v-for="item in classificationOne"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
              </el-select>
              <el-select v-model="form.typeSecondUuid" placeholder="二级分类">
                  <el-option
                      v-for="item in classificationTwo"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
              </el-select>
              <el-select v-model="form.status" placeholder="状态">
                  <el-option label="全部" value=""> </el-option>
                  <el-option label="待审核" value="REVIEWING"> </el-option>
                  <!--<el-option label="审核通过" value="UNRELEASED"> </el-option>-->
                  <el-option label="审核通过" value="RELEASED"> </el-option>
                  <el-option label="审核拒绝" value="REJECT"> </el-option>

              </el-select>
              <el-select v-model="form.attribute" placeholder="模型属性">
                  <el-option label="全部" value=""> </el-option>
                  <el-option label="免费" value="FREE"> </el-option>
                  <el-option label="付费" value="PAY"> </el-option>
                  <el-option label="预览" value="BROWSE"> </el-option>
              </el-select>
              <el-select v-model="form.isRecommended" placeholder="是否推荐">
                  <el-option label="全部" value=""> </el-option>
                  <el-option label="已推荐" value="1"> </el-option>
                  <el-option label="未推荐" value="0"> </el-option>
              </el-select>
              <el-button class="searchBtn" @click="search">搜索</el-button>
              <el-button type="text" class="resetBtn" @click="resetData">
                  <i class="iconfont icon-qingchushujuku"></i>
                  <span>清除条件</span>
              </el-button>
          </div>
          <div class="orderListTable">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              class="tableContent"
            >
            <el-table-column
                prop="designer"
                label="设计师名称"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="模型名称"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="imgs"
                label="缩略图"
                header-align="center"
                align="center"
                show-overflow-tooltip
                width="200"
              >
                <template slot-scope="scope">
                  <img :src="scope.row.imgs" alt="" />
                </template>
              </el-table-column>
              <el-table-column
                prop="uptime"
                label="上传时间"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="firstClass"
                label="一级分类"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="secondClass"
                label="二级分类"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="modelAttribute"
                label="模型属性"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="money"
                label="价格(元)"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
                <el-table-column
                    prop="sort"
                    align="center"
                    header-align="center"
                    label="推荐位" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.sort===0?'':scope.row.sort }}
                    </template>
                </el-table-column>
              <el-table-column
                prop="status"
                align="center"
                header-align="center"
                :formatter="showExamineStatus"
                label="状态"
              >
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
                width="230"
              >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        v-if="(scope.row.status === '已发布' || scope.row.status === '审核通过')"
                        @click="setSortInfo(scope.row)"
                    >推荐位</el-button
                    >
                    <el-button type="text" size="small" v-if="(scope.row.status === '已发布' || scope.row.status === '审核通过') && scope.row.sort" @click="cancelRecommended(scope.row)">取消推荐</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status === '待审核'"
                    @click="toDialog(0,scope.row)"
                    >审核</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status != '待审核'"
                    @click="toDialog(1,scope.row)"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handlePageChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!--审核查看弹出框-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <div class="dialogBox">
        <div class="details">
          <div class="detailsItem">
            <h3>模型信息</h3>
            <div class="itemContent">
              <div class="one-row">
                <div class="label">设计师名称:</div>
                <div class="name" v-text="model.creatorName">我是设计师</div>
              </div>
              <div class="one-row">
                <div class="label">模型名称:</div>
                <div class="name" v-text="model.modelName">某某模型</div>
              </div>
              <div class="two-row"  style="width:100%">
                <div class="label">封面图片:</div>
                  <div class="itemPictureContent">
                      <div class="one-row"  v-for="(items, index) in model.urlList" :key="index" v-if="items.fileType == 'MAIN_IMG'">
                          <div class="image">
                              <img :src="items.url" alt="">
                          </div>
                      </div>
                  </div>
              </div>
              <div class="two-row"  style="width:100%">
                <div class="label">模型图片:</div>
                  <div class="itemPictureContent">
                      <div class="one-row"  v-for="(items, index) in model.urlList" :key="index" v-if="items.fileType == 'IMG'">
                          <div class="image">
                              <img :src="items.url" alt="">
                          </div>
                      </div>
                  </div>
              </div>
                <div class="two-row two-row2">
                    <div class="label lables">模型文件:</div>
                    <div class="itemPictureContent" style="display:flex;justify-content: flex-start;">
                        <div class="name" style="margin-bottom: 10px;margin-right:20px" v-for="(items, index) in model.urlList" :key="index" v-if="items.fileType == 'FILE'">
                            <div class="two-row2Img_box" @click="handPreview(items,'model')">
                              <img :src="items.url" alt="" class="two-row2Img">
                              <div class="two-row2Img_model">预览模型</div>
                            </div>
                            <div><a :href="items.modelUrl" :download="items.name"  style="color: #409EFF;">{{items.name}}</a></div>
                        </div>
                    </div>
                </div>
              <div class="two-row">
                <div class="label">上传时间:</div>
                <div class="name" v-text="model.createDate">2021-11-19</div>
              </div>
              <div class="two-row">
                <div class="label">一级分类:</div>
                <div class="name" v-text="model.firstClass">工业模型</div>
              </div>
              <div class="two-row">
                <div class="label">二级分类:</div>
                <div class="name" v-text="model.secondClass">机床配件</div>
              </div>
              <div class="two-row">
                <div class="label">模型属性:</div>
                <div class="name" v-text="model.attributeCn">免费</div>
              </div>
              <div class="two-row">
                <div class="label">价格:</div>
                <div class="name" v-text="model.price">免费</div>
              </div>
                <div class="two-row">
                    <div class="label">SEO关键字:</div>
                    <div class="name" v-text="model.metaKeywords"></div>
                </div>
                <div class="two-row">
                    <div class="label">SEO描述:</div>
                    <div class="name" v-text="model.metaDescription"></div>
                </div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 1">
          <h3>审核结果</h3>
          <div class="auditContent">
            <el-tag type="success" effect="dark" v-if="model.status == 'UNRELEASED'">审核已通过</el-tag>
            <el-tag type="success" effect="dark" v-if="model.status == 'RELEASED'">审核已通过，并发布</el-tag>
            <el-tag type="danger" effect="dark" v-if="model.status == 'REJECT'">审核已驳回</el-tag>
            <div class="cause" v-if="model.status == 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent">
                  {{model.reason}}
              </div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 0">
          <h3>审核</h3>
          <div class="auditContent">
            <el-radio-group v-model="auditForm.status">
              <el-radio label="RELEASED">通过</el-radio>
              <el-radio label="REJECT">驳回</el-radio>
            </el-radio-group>
            <div class="cause" v-if="auditForm.status === 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" style="width: 100%">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                  placeholder="请输入驳回原因"
                  v-model="auditForm.reason"
                >
                </el-input>
              </div>
            </div>
            <div class="auditEnter">
              <el-button type="primary" @click="auditSubmit(model.uuid)">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

      <!-- 设置推荐位 -->
      <el-dialog
          title="设置推荐位"
          :visible.sync="sortDialogVisible"
          width="800px">
          <div class="dialogContent">
              <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="120px">
                  <el-form-item prop="sort" label="推荐位">
                      <el-input-number v-model="ruleForm.sort"  :min="1"></el-input-number>
                  </el-form-item>
                  <el-form-item class="submitButtonClass">
                      <el-button type="primary" @click="submit">提交</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
    <!-- 3d预览 -->
    <three-d
      ref="threeBox"
      :innerVisible="innerVisible"
      @closeDlog="closeDlog"
    ></three-d>
  </div>
</template>

<script>
    import {auditModel, modelListByPage, getDictionaryGroup, getDictionaryItem, getDictionaryDetail,getDictionaryGroupDetail, setModelSort} from "../../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import threeD from "../../../components/threeD/index";

export default {
  components: {threeD},
  data() {
    return {
      innerVisible: false,

      //   createDateValue: null,
        form: {creatorName:"",modelName:""},
        auditForm: {},
      typeValue: "",
      classificationOne: [],
      classificationTwo: [],
      attributeModel:'',
      statusWork: "",
      tableData: [
      ],
      current: 0,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      title: "",
      auditRadio: "",
      textarea: "",
      currentAudit: "",
        model:{},
        sortDialogVisible:false,
        ruleForm:{
            sort:'',
        },
        rules: {
            sort: [
                {required: true, message: '请设置推荐排序', trigger: 'change'}
            ],
        },
        info:{},
    };
  },
  computed: {
    contentViewHeight() {
      let height = document.documentElement.clientHeight - 120;
      return { minHeight: height + "px" };
    },
  },
    created() {
        this.getDictionaryItem();
        this.search();
    },
  methods: {
      showExamineStatus(row, column){
          // debugger
          if(row.modelDetail.status=="RELEASED" || row.modelDetail.status=="UNRELEASED"){
              return "审核通过";
          }else if(row.modelDetail.status=="REVIEWING"){
              return "待审核";
          }else if(row.modelDetail.status=="REJECT"){
              return "审核拒绝";
          }
      },
      submit(){
          this.info.sort = this.ruleForm.sort;
          setModelSort({modelUuid:this.info.uuid,sort:this.ruleForm.sort}).then((res)=>{
              if(res.success) {
                  this.$message.success('设置成功！');
                  this.sortDialogVisible = false;
                  this.search();
              }
          });
      },
      cancelRecommended(item){
          this.$confirm('确定取消推荐吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              setModelSort({modelUuid:item.uuid,sort:-1}).then((res)=>{
                  if(res.success) {
                      this.$message.success('设置成功！');
                      this.sortDialogVisible = false;
                      this.search();
                  }
              });
          }).catch(() => {})
      },
      setSortInfo(item){
          this.info = item;
          if(item.sort!=""){
              this.ruleForm.sort = item.sort;
          }
          this.sortDialogVisible = true;
      },
      // 获取字典值
      getDictionaryItem(){
          getDictionaryGroup({parentCode: 'MODEL_CATEGORIES'}).then((res)=>{
              res.forEach((item, index) => {
                  this.classificationOne.push({'name':item.name, 'id' : item.uuid, 'groupId': item.groupUuid});
              });
          });
      },
      classificationOneChange(value){
          getDictionaryItem({groupUuid: value}).then((res)=>{
              res.forEach((item, index) => {
                  this.classificationTwo.push({'name':item.name, 'id' : item.uuid, 'groupId': item.groupUuid});
              });
          });
      },
    resetData() {
        //   this.createDateValue = null;
        this.form.creatorName = "";
        this.form.modelName = "";
        this.form.isRecommended = "";
        this.classificationOne = [];
        this.classificationTwo = [];
        this.getDictionaryItem();
        this.form.typeFirstUuid = "";
        this.form.typeSecondUuid = "";
        this.form.status = "";
        this.form.attribute = ""
        this.current = 1;
        this.search();
    },
    // 分页
      handleCurrentChange(val) {
          this.current = val;
      },
      handlePageChange(val) {
          this.current = val;
          this.search();
      },
      search(){
          this.form.current = this.current;
          this.form.pageSize = this.pageSize;
          modelListByPage(this.form).then((res)=>{
              this.tableData = [];
              if(res != null && res.list != null && res.list.length > 0){
                  this.total = res.total;
                  res.list.forEach((item, index) => {
                      let model = {};
                      model.modelDetail = item;

                      model.uuid = item.uuid;
                      model.designer = item.creatorName;
                      model.name = item.modelName;
                      model.imgs = item.imgUrl;
                      model.uptime = item.createDate;
                      // getDictionaryGroupDetail(item.typeFirstUuid).then((res)=>{
                      //     model.firstClass = res.name;
                      //     model.modelDetail.firstClass = res.name;
                      // });
                      // getDictionaryDetail(item.typeSecondUuid).then((res)=>{
                      //     model.secondClass = res.name;
                      //     model.modelDetail.secondClass = res.name;
                      // });
                      model.firstClass =  item.typeFirstName;
                      model.modelDetail.firstClass = item.typeFirstName;
                      model.secondClass = item.typeSecondName;
                      model.modelDetail.secondClass = item.typeSecondName;
                      model.modelAttribute = item.attributeCn;
                      model.money = item.price;
                      model.status = item.statusCn;
                      model.sort = item.sort;
                      this.tableData.push(model);
                  });
              }else{
                  this.total = 0;
              }
          });
      },
    // 审核查看
    toDialog(val,model) {
      this.dialogVisible = true;
      this.model = model.modelDetail;
      this.currentAudit = val;
      if (val === 0) {
        this.title = "审核详情";
          this.auditForm = {};
      } else {
        this.title = "查看详情";
      }
    },
    // 确定审核
    auditSubmit(uuid) {
        if(this.auditForm.status=== undefined){
            this.$message.warning('请选择审核结果！');
        } else if(this.auditForm.status === 'REJECT' && this.auditForm.reason === undefined){
            this.$message.warning('请输入驳回原因！');
        } else {
            this.auditForm.uuid = uuid;
            auditModel(this.auditForm).then((res) => {
                if (res) {
                    this.$message.success('审核成功！');
                    this.dialogVisible = false;
                    this.search();
                }
            });
        }
    },
    // 3D模型预览
    handPreview(info,type) {
      this.$refs.threeBox.threeAnimal(info,type);
      this.innerVisible = !this.innerVisible;
    },
    closeDlog(index) {
      this.innerVisible = index;
    },
  },
};
</script>

<style scoped lang="less">
.orderManagementClass {
  position: relative;
  width: 100%;
  padding: 0 20px 20px;
  .orderManagementContent {
    background: #fff;
        min-width: 1390px;
    .printOrderListBox {
      padding: 20px;
        .orderSearchBox {

            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

      .tableContent {
        min-height: 600px;

        /deep/ .el-table__header {
          tr {
            th {
              border-right: none;
            }
          }

          /deep/ .el-table__cell {
            padding: 5px 0;
            background: #f2f5fc;
          }
        }

        /deep/ .el-table__body {
          img {
            vertical-align: middle;
            width: 52px;
            height: 50px;
          }
        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
  // 审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;
  }
}

  .dialogBox {
    .details {
      .detailsItem {
        padding-bottom: 20px;
        h3 {
          font-weight: 700;
          font-size: 16px;
          color: #000;
          margin-top: 0;
          letter-spacing: 1px;
          // border-bottom: 1px solid #ddd;
          padding-bottom: 15px;
        }
        .itemContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          // padding: 0 30px;
          .one-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 1);
            }
            .name {
              color: #000;
              color: rgba(0, 0, 0, 0.65);
            }
          }
          .two-row2 {
            width: 100% !important;
            text-align: center;
            .two-row2Img_box {
              position: relative;
              cursor: pointer;
              &:hover {
                .two-row2Img_model {
                  display: block;
                }
              }
              .two-row2Img {
                height: 120px;
              }
              .two-row2Img_model {
                  display: none;
                  position: absolute;
                  top: 0;
                  width: 100%;
                  height: 120px;
                  color: #fff;
                  font-weight: bold;
                  line-height: 120px;
                  background: rgba(0, 0, 0, 0.459);
                }
            }

          }
          .two-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }

            .name {
              color: #000;
              color: rgba(0, 0, 0, 0.65);
              a{
                color:rgba(0, 0, 0, 0.65) ;
              }
              img {
                  width: 216px;
              }
            }
          }
        }
        .itemPictureContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          // padding: 0 30px;
          padding-right: 30px;
          justify-content: space-between;
          .one-row {
            width: 30%;
            margin-bottom: 22px;
            img {
              width: 224px;
              height: 143px;
              border: 1px solid #ddd;
            }
            .name {
              text-align: center;
              padding-top: 10px;
              font-size: 14px;
              display: flex;
              .label {
                min-width: 80px;
              }
              // .labels{

              // }
            }
          }
        }
      }
    }
    .audit {
      padding-bottom: 20px;
      h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 0;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
      }
      .auditContent {
        // padding: 0 30px;
      }
      .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
          min-width: 80px;
          color: #3a8ee6;
        }
        .causeContent {
          color: #000;
        }
      }
      .auditEnter {
        text-align: center;
        padding-top: 20px;
        button {
          width: 120px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/designAudit/modelAudit.vue